import React, { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPenToSquare, faTrash } from '@fortawesome/free-solid-svg-icons';
import TableLoader from './Loader/TableLoader'; 

interface Item {
  ticket_id: number;
  ticket_group_code: string;
  // Add more properties as per your item structure
}

interface currentLatestTableProps {
  items: Item[];
  loading: boolean;
  onView: (id: number) => void;
  onEdit: (id: number) => void;
  onDelete: (id: number) => void;
}

export default function CurrentLatestTicketTable({ 
  items,
  loading,
  onView, 
  onEdit, 
  onDelete 
}: currentLatestTableProps) {
  const [latestPage, setLatestPage] = useState(1);
  const latestPerPage = 10;
  const totalPages = Math.ceil(items.length / latestPerPage);
  const indexOfLastLatest = latestPage * latestPerPage;
  const indexOfFirstLatest = indexOfLastLatest - latestPerPage;
  const currentLatest = items.slice(indexOfFirstLatest, indexOfLastLatest);

  const nextLatestPage = () => {
    if (latestPage < totalPages) { 
      setLatestPage(latestPage + 1) 
    }
  };

  const prevLatestPage = () => {
    if (latestPage > 1) { 
      setLatestPage(latestPage - 1) 
    }
  };

  return (
    <>
      {loading ? 
        (
          <TableLoader />
        )
        
        :

        (
          <table>
            <thead className="bg-gray-200">
              <tr>
                <th style={{ width: '90%' }}>Ticket Group Code</th>
                <th style={{ width: '10%' }} className="text-center">Action</th>
              </tr>
            </thead>

            <tbody>
                {currentLatest.length !== 0 ? 
                  (
                    currentLatest.map(item => (
                      <tr key={item.ticket_id}>
                          <td>{item.ticket_group_code}</td>
                          <td className="text-center">
                              <button 
                                onClick={() => onEdit(item.ticket_id)} 
                                data-tooltip-id='edit'>
                                <FontAwesomeIcon icon={faPenToSquare} className="text-sx text-white bg-red-600 rounded-md p-1 mr-2" />
                              </button>

                              <button 
                                onClick={() => onDelete(item.ticket_id)} 
                                type='button' 
                                data-tooltip-id='delete'>
                                <FontAwesomeIcon icon={faTrash} className="text-sm text-white bg-gray-600 rounded-md p-1" />
                              </button>
                          </td>
                      </tr>
                    ))
                  ) 
                  
                  :

                  (
                    <tr>
                      <td colSpan={2} className="text-center">No data available!</td>
                    </tr>
                  )
                }
            </tbody>
          </table>
        )
      }

      {totalPages > 1 && (
        <div className="flex justify-center items-center mt-4 space-x-4">
          <button
            onClick={() => setLatestPage(1)}
            className="px-3 py-1 rounded disabled:opacity-50 text-white bg-gray-500"
            disabled={latestPage === 1}>
            First
          </button>

          <button
            onClick={prevLatestPage}
            className="px-3 py-1 rounded disabled:opacity-50 text-white bg-gray-500"
            disabled={latestPage === 1}>
            Prev
          </button>

          {/* Page number buttons */}
          {[...Array(totalPages)].map((_, index) => {
            const pageNum = index + 1;
            const pageRange = 1;
            const startPage = Math.max(1, latestPage - pageRange);
            const endPage = Math.min(totalPages, latestPage + pageRange);

            if (pageNum >= startPage && pageNum <= endPage) {
              return (
                <button
                  key={pageNum}
                  onClick={() => setLatestPage(pageNum)}
                  className={`px-3 py-1 rounded ${
                    latestPage === pageNum
                      ? "bg-red-600 text-white"
                      : "bg-gray-200 text-black"
                  }`}
                >
                  {pageNum}
                </button>
              );
            }
            return null;
          })}

          <button
            onClick={nextLatestPage}
            className="px-3 py-1 rounded disabled:opacity-50 text-white bg-red-500"
            disabled={latestPage === totalPages}>
            Next
          </button>

          <button
            onClick={() => setLatestPage(totalPages)}
            className="px-3 py-1 rounded disabled:opacity-50 text-white bg-red-500"
            disabled={latestPage === totalPages}>
            Last
          </button>
        </div>
      )}
    </>
  )
}